
import axios from 'axios';


export const  axios_courtier_updateauthtarifs = async ({id_courtier,autorisation})=>{
        return axios.post(`/courtier/updateauthtarifs`,{id_courtier,autorisation},
                                                     {headers:{ 'Accept': 'application/json', 'Content-Type': 'application/json'   }});
}
    
export const  axios_courtier_getall = async ()=>{
    return axios.get(`/courtier/getall`,{headers:{'Accept':'application/json','Content-Type':'application/json'}});
}

export const  axios_courtier_getinfoscourtier = async (courtier)=>{

    return await axios.post(`/courtier/getinfoscourtier/`,{courtier},{headers:{'Accept':'application/json','Content-Type':'application/json'} }); 
}
    
export const  axios_courtier_sendinfoscoutier = async (data)=>{
    return await axios.post(`/courtier/sendinfoscoutier/`,data, {headers: { 'Accept': 'application/json', "Content-Type": "multipart/form-data"} }) ; 
}

export const  axios_courtier_create = async (data)=>{
    return await axios.post(`/courtier/create/`,data, {headers: { 'Accept': 'application/json', "Content-Type": "multipart/form-data"} }) ; 
}




